import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { apiCallBegan } from 'api/api';
import ClientConfig from 'src/config/config';
import { applyMixpanelIdentity, resetMixpanel } from 'src/analytics/mixpanel/mixpanel-client';
import { IUser } from 'src/common/interfaces/user.interfaces';

const initialState: { user: Pick<IUser, 'email' | 'userName'>; users: IUser[] } = {
  user: {
    userName: '',
    email: '',
  },
  users: [] as IUser[],
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: {
      prepare: (user: IUser) => {
        const { enableMixpanel } = ClientConfig.config;
        const { email } = user;
        if (enableMixpanel && email) {
          applyMixpanelIdentity(email);
        }
        if (!email) {
          resetMixpanel();
        }
        return {
          payload: user,
        };
      },
      reducer: (state, action: PayloadAction<IUser>) => {
        state.user = action.payload;
      },
    },
    setUsers: (state, action: PayloadAction<{ users: IUser[] }>) => {
      state.users = action.payload.users;
    },
  },
});

export default slice.reducer;

export const { setUser, setUsers } = slice.actions;

export const getUser = () =>
  apiCallBegan({
    url: '/api/user',
    method: 'GET',
    onSuccess: setUser,
  });

export const getUsers = () =>
  apiCallBegan({
    url: '/api/company/users',
    method: 'GET',
    onSuccess: setUsers,
  });
